import classNames from "classnames/bind";
import React from "react";
import styles from "./DropdownInput.module.scss";
import { useDropdownContext } from "./DropdownContext";
import { Icon, IconLoading } from "../../Icon";

const cx = classNames.bind(styles);

const DropdownIcon = () => {
  const { isMenuOpen, isLoading } = useDropdownContext();

  return (
    <div
      className={cx("iconContainer", {
        active: isMenuOpen,
      })}
      role="presentation"
    >
      {isLoading ? (
        <IconLoading speed="fast" />
      ) : (
        <Icon
          variant="caret-down"
          size={20}
          weight="thin"
        />
      )}
    </div>
  );
};

export default DropdownIcon;
